import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './errors';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: true,
      retry: (count, err) => {
        // Never retry auth/validation errors; retry network/5xx up to 2 times.
        if (err instanceof ApiError && err.status && err.status < 500) return false;
        return count < 2;
      },
    },
    mutations: { retry: 0 },
  },
});
